import type { JSX } from 'react'

import CustomButton from '../CustomButton'
import styles from './ErrorFallback.module.scss'

export const ErrorFallback = (): JSX.Element => {
  const onClick = (): void => {
    if (typeof globalThis.window !== 'undefined') {
      const path = globalThis.location.pathname.split('/')[1]
      globalThis.location.assign(`${globalThis.location.origin}/${path}`)
    }
  }

  return (
    <div className={styles.wrapper} role="alert">
      <h2 className={styles.heading}>Ooops, something went wrong :(</h2>
      <CustomButton className="mt-4" onClick={onClick}>
        Refresh
      </CustomButton>
    </div>
  )
}
